<template>

  <div class="arena-sched">

    <div class="header sched-row">
      <div class="title-cell">
        Game
      </div>


      <div class="col cell" v-for="(dates, i) in scheduleStartDates" :key="i">
        <div class="round-number">{{i+1}}</div>
        <div class="round-start-date">{{dates.start.format('MM/DD')}} - {{dates.end.format('MM/DD')}}</div>
      </div>
    </div>

      <div :class="{'sched-row': true, focused: mobileFocus === i}"
           v-for="(team, i) in data"
           :key="team.abbreviation"
      >
        <div class="title-cell" @click="handleTitleCellClick(team.abbreviation, i)">
          <div class="title-wrapper">
          <span class="team-icon">
            <S3Image width="28" class="icon-img" :src="'teams/' + team.logo"/>
          </span>
            <span class="team-title">
          {{team.name}}
        </span>
          </div>
        </div>
      <div class="cell"
           v-for="opponent in team.schedule"
           :key="opponent.abbreviation"
           @click="selectTeam(opponent.abbreviation)"
      >
        <span class="team-icon">
          <S3Image width="28" class="icon-img" :src="'teams/' + opponent.logo"/>
        </span>
        <span class="team-title">
          {{opponent.abbreviation}}
        </span>

      </div>

    </div>


  </div>


</template>

<script>
	import S3Image from "@/components/theme/S3Image";
	export default {
		name: "Schedule",
		components: {S3Image},
		data: function () {
			return {
				mobileFocus: 0
			}
		},
		props: ["data"],
		methods: {
			selectTeam(abbrev) {
				this.$emit('teamselected', abbrev)
			},
			handleTitleCellClick(abbrev, idx) {
				const _t = this;
				_t.selectTeam(abbrev);
				_t.mobileFocus === idx ? _t.mobileFocus = null : _t.mobileFocus = idx;

			}
    },
		computed: {
			scheduleStartDates: function () {
				if (!this.data || !this.data.length) return [];
				let scheduleArray = this.data[0].schedule;

				return scheduleArray.map(d => {return {start: d.round_start, end: d.round_end}}) //returns array of moment objects

			}
		}
	}
</script>

<style lang="less" scoped>


  @import "../../../assets/less/palette.less";
  @import "../../../assets/less/theme.less";

  @bg-color: @light-background;
  @fg-color: @primary-4;

  @schedulewidth: 1000px;
  @titlecellwidth: 180px;


  .arena-sched {
    width: 1000px;
    margin: 20px auto;

    .sched-row {
       display: flex;
       flex-wrap: nowrap;
      justify-content: flex-start;
      width: 100%;
    }


    .header {

      .round-number {
        font-size: 18px;
        font-weight: bolder;
      }

      .round-start-date {
         font-size: 12px;
      }

    }

    .title-cell {
      cursor: pointer;
      width: 200px;
      background-color: @bg-color;
      color: @fg-color;
      margin: 4px;
      border-radius: 4px;
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;

      .team-icon .timg {
         width: 40px;
      }

      .team-title {
        margin-left: 8px;
      }
    }

    .cell {
      cursor: pointer;
      display: flex;
      flex-direction: column;
       background-color: @bg-color;
      color: @fg-color;
      margin: 4px;
      border-radius: 4px;
      align-items: center;
      justify-content: center;
      flex: 1;
      padding: 3px;


      .team-icon img {
         width: 30px;
      }

    }

  }  //arena-sched

  @media (max-width: @breakpoint-medium) {

    .arena-sched {
      width: 90vw;

      .header.sched-row {
        display: none;
      }

      .sched-row {
        flex-direction: column;
        margin: 2px auto;

        .title-cell {
          width: 100%;

          .team-title::after {
            content: '⌄';
            margin-left: 5px;
            font-size: 22px;
          }
        }

        .cell {
          display: none;
        }

        &.focused {

          margin: 40px auto;

          .title-cell {
            background: none;
            border-bottom: 2px solid @bg-color;
            margin-bottom: 10px;
            border-radius: 0;
            color: @bg-color;

            .team-title::after {
              content: '⌃';
            }
          }

          .cell {
            width: 100%;
            flex-direction: row;
            display: block;

            & > * {
              margin: 1px 3vw;
            }
          }
        }

      }

    }

  }

</style>
